import { withInstall } from '@vuesax-plus/utils'
import Select from './src/select.vue'

export const VsSelect = withInstall(Select)
export default VsSelect

export * from './src/select'
